// extracted by mini-css-extract-plugin
module.exports = {"container":"SignInForm_container__1qP_E","backButton":"SignInForm_backButton__1VLnN","button":"SignInForm_button__mX4SW","link":"SignInForm_link__1Of3Z"};